export default __webpack_public_path__ + "static/media/07.b0c9d011.jpg";